/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{useState as e,useEffect as n}from"react";const t=t=>{const[o,r]=e(!1);return n((()=>{const e=({key:e})=>{e===t&&r(!0)},n=({key:e})=>{e===t&&r(!1)};return window.addEventListener("keydown",e),window.addEventListener("keyup",n),()=>{window.removeEventListener("keydown",e),window.removeEventListener("keyup",n)}}),[t]),o};export{t as default};
//# sourceMappingURL=useKeyPress.js.map
